var map = {
	"./accounting/coa-category.js": "4451",
	"./accounting/coa-mapping.js": "769b",
	"./accounting/coa-setup.js": "f6ec",
	"./accounting/journal-entry.js": "827c",
	"./auth.js": "831c",
	"./booking/available-schedule.js": "4a6c",
	"./booking/table-booking.js": "4d31",
	"./booking/table-profile.js": "8c27",
	"./corporate/address.js": "3e79",
	"./corporate/bank-profile.js": "c41c",
	"./corporate/branch.js": "d01a",
	"./corporate/company.js": "1644",
	"./couter/setup.js": "b44c",
	"./customer/location-visitation.js": "99a2",
	"./customer/profile.js": "60fe",
	"./customer/visitation.js": "6475",
	"./error.js": "fe0e",
	"./exchange-rate/currency-exchange.js": "e9bc",
	"./exchange-rate/currency.js": "3bab",
	"./expense/daily-cash-advance.js": "c853",
	"./expense/daily-expense.js": "6193",
	"./expense/expense-category.js": "a7cc",
	"./expense/expense-item.js": "3e5f",
	"./expense/expense-posting.js": "6862",
	"./home.js": "3165",
	"./hr/approval-request.js": "ffb6",
	"./human-resource/attendance-device.js": "c41a",
	"./human-resource/basic-salary-formula.js": "a12d",
	"./human-resource/basic-salary.js": "bfd9",
	"./human-resource/card-activator.js": "e548",
	"./human-resource/daily-attendance.js": "bd63",
	"./human-resource/employee.js": "07f8",
	"./human-resource/holiday-rule.js": "fd65",
	"./human-resource/holiday.js": "922b",
	"./human-resource/job-detail.js": "ea38",
	"./human-resource/job-level.js": "1f00",
	"./human-resource/job-title.js": "4634",
	"./human-resource/leave-initial-balance.js": "f053",
	"./human-resource/leave-record.js": "3b98",
	"./human-resource/leave-rule.js": "5c6d",
	"./human-resource/leave-sub-item.js": "7d95",
	"./human-resource/monthly-attendence.js": "25d5",
	"./human-resource/nationality.js": "6827",
	"./human-resource/organizational-chart.js": "7c12",
	"./human-resource/organizational-structure.js": "9f45",
	"./human-resource/position-hierarchy.js": "dc12",
	"./human-resource/shift-management.js": "8603",
	"./human-resource/work-schedule.js": "19f7",
	"./mart-sale/deleted-items-list.js": "7dfb",
	"./mart-sale/order.js": "5ebd",
	"./payroll/Item-allowance.js": "346f",
	"./payroll/first-cycle-paid.js": "a388",
	"./payroll/fixed-allowance.js": "5443",
	"./payroll/fixed-incentive-bonus.js": "81d8",
	"./payroll/item-compensate.js": "4c27",
	"./payroll/item-deduction.js": "9325",
	"./payroll/item-incentive-bonus.js": "4c7f",
	"./payroll/item-overtime.js": "2935",
	"./payroll/monthly-allowance.js": "edd5",
	"./payroll/monthly-compensate.js": "76f4",
	"./payroll/monthly-deduction.js": "7723",
	"./payroll/monthly-incentive-bonus.js": "198e",
	"./payroll/monthly-over-time.js": "9187",
	"./payroll/overtime-rule-by-shift.js": "d44e",
	"./payroll/pay-user-variable.js": "76c4",
	"./payroll/payroll-calculation.js": "a7d2",
	"./payroll/payroll-cycle-date.js": "7766",
	"./payroll/payroll-cycle.js": "65c2",
	"./payroll/payroll-template.js": "9435",
	"./payroll/payslip-template.js": "fd9a",
	"./payroll/pension-contribution-wage.js": "5c23",
	"./payroll/pension-rate.js": "bb27",
	"./payroll/tax-range.js": "928f",
	"./product/add-on.js": "6052",
	"./product/assembly.js": "998a",
	"./product/cost.js": "e695",
	"./product/group.js": "944c",
	"./product/history.js": "5fe3",
	"./product/label.js": "1dab",
	"./product/location.js": "9296",
	"./product/pallet.js": "12e6",
	"./product/price.js": "1511",
	"./product/product-category.js": "270c",
	"./product/profile.js": "ea6d",
	"./product/specification.js": "0de5",
	"./product/uom-category.js": "48c7",
	"./project-mgt/main.js": "0253",
	"./promotion/setup.js": "4fec",
	"./purchase-order-v2/order.js": "2d5a",
	"./purchase-order/order.js": "37af",
	"./purchase-request/purchase-request.js": "5995",
	"./report/accounting.js": "b2ce",
	"./report/additional-info.js": "7d4f",
	"./report/daily.js": "e021",
	"./report/expense.js": "037b",
	"./report/finance.js": "a251",
	"./report/human-resource.js": "3d16",
	"./report/inventory.js": "0b96",
	"./report/payroll.js": "d052",
	"./report/project-mgt.js": "de4f",
	"./report/sale.js": "8a09",
	"./report/service-order.js": "78cc",
	"./restaurant-order/counter-checkout.js": "8b5a",
	"./restaurant-order/customer-display-order.js": "7942",
	"./restaurant-order/customer-order.js": "2d28",
	"./restaurant-order/kdu.js": "f219",
	"./restaurant-sale/counter-checkout.js": "6e58",
	"./restaurant-sale/customer-order.js": "3916",
	"./restaurant-sale/kdu.js": "bdf5",
	"./restaurant-sale/kot-bot-printer.js": "f4de",
	"./restaurant-sale/product-price-schema.js": "6806",
	"./restaurant-sale/sale-product-deleted.js": "8d2e",
	"./sale/sale-area.js": "ccd1",
	"./security/login-out.js": "f2b1",
	"./security/role.js": "2001",
	"./security/user.js": "2aad",
	"./service-management/home.js": "3988",
	"./service-management/service-request.js": "83f8",
	"./setting/approval-request-flow.js": "f6c7",
	"./setting/routing.js": "a857",
	"./stock/adjustment.js": "f7ad",
	"./stock/inventory-list-v2.js": "7120",
	"./stock/inventory-list.js": "d404",
	"./stock/return-from-vendor.js": "1708",
	"./stock/return-to-vendor.js": "0810",
	"./stock/stock-close.js": "d2b2",
	"./stock/stock-confirm.js": "fe2a",
	"./stock/stock-count.js": "f1bd",
	"./stock/stock-in-v2.js": "dd33",
	"./stock/stock-in.js": "f11c",
	"./stock/stock-return.js": "8e92",
	"./stock/stock-transfer.js": "f2d0",
	"./stock/trade-in.js": "6ea2",
	"./stock/transfer-by-serial.js": "acc1",
	"./stock/warehourse.js": "e60c",
	"./stock/write-off.js": "36f7",
	"./supplier/payment.js": "2854",
	"./supplier/profile.js": "d4be",
	"./website/news-category.js": "8c5e",
	"./website/setup-banner.js": "368b",
	"./website/setup-news.js": "7907",
	"./website/setup-offer.js": "5d10",
	"./website/setup-our-farmers.js": "fd48",
	"./wholesale/borrowing-spare-part.js": "d8ba",
	"./wholesale/delivery-order.js": "1408",
	"./wholesale/operation-v2.js": "47ff",
	"./wholesale/operation.js": "7ed2",
	"./wholesale/quotation.js": "2c2c",
	"./wholesale/receipt.js": "44a8",
	"./wholesale/replacement.js": "2668",
	"./wholesale/sale-contract.js": "5d65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61d6";